var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNullLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 320 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-21,.cls-22,.cls-23,.cls-24,.cls-29,.cls-33,.cls-34,.cls-35,.cls-36,.cls-43,.cls-44,.cls-45,.cls-46,.cls-51{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#e8eaed;}.cls-7{fill:#bdc1c6;}.cls-23,.cls-24,.cls-34,.cls-36,.cls-45,.cls-46,.cls-8{opacity:0.2;}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-7);}.cls-12,.cls-13{stroke:silver;}.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-21,.cls-22,.cls-23,.cls-24,.cls-29,.cls-33,.cls-34,.cls-35,.cls-36,.cls-43,.cls-44,.cls-45,.cls-46{stroke-linecap:round;}.cls-12,.cls-13,.cls-21,.cls-22,.cls-23,.cls-24,.cls-29,.cls-33,.cls-34,.cls-35,.cls-36,.cls-43,.cls-44,.cls-45,.cls-46{stroke-linejoin:round;}.cls-12,.cls-21,.cls-24,.cls-33,.cls-36,.cls-43,.cls-46{stroke-width:2px;}.cls-14{stroke:#4285f4;}.cls-14,.cls-15,.cls-16,.cls-17{stroke-miterlimit:10;stroke-width:7px;}.cls-15,.cls-21,.cls-22,.cls-23,.cls-24{stroke:#ea4335;}.cls-16,.cls-33,.cls-34,.cls-35,.cls-36{stroke:#34a853;}.cls-17{stroke:#fbbc04;}.cls-18{fill:#f8f9fa;}.cls-19,.cls-51{opacity:0.1;}.cls-20{fill:#ea4335;}.cls-23,.cls-24,.cls-30,.cls-34,.cls-36,.cls-39,.cls-40,.cls-43,.cls-45,.cls-46,.cls-48{mix-blend-mode:multiply;}.cls-25{fill:silver;}.cls-26{fill:#fff;}.cls-27,.cls-30,.cls-38{opacity:0.5;}.cls-27{fill:url(#linear-gradient-8);}.cls-28{fill:#ea3f32;}.cls-29{stroke:#fff;stroke-width:0.93px;}.cls-30{fill:url(#linear-gradient-9);}.cls-31{fill:url(#linear-gradient-10);}.cls-32{fill:#34a853;}.cls-37{fill:url(#linear-gradient-11);}.cls-39{opacity:0.3;fill:url(#linear-gradient-12);}.cls-40{fill:url(#linear-gradient-13);}.cls-41{clip-path:url(#clip-path);}.cls-42{fill:#4285f4;}.cls-43,.cls-44,.cls-45,.cls-46{stroke:#2196f3;}.cls-47{fill:url(#linear-gradient-14);}.cls-48{fill:url(#linear-gradient-15);}.cls-49{fill:#1d6bdd;}.cls-50{fill:url(#radial-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 109.48,
    y1: 119.89,
    x2: 69.22,
    y2: 119.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9aa0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9aa0a6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 130.62,
    y1: 129.93,
    x2: 93.67,
    y2: 129.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 180.61,
    y1: 147.56,
    x2: 135.38,
    y2: 147.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 190.3,
    y1: 167.54,
    x2: 190.3,
    y2: 126.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9aa0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9aa0a6",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9aa0a6",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9aa0a6",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9aa0a6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9aa0a6",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9aa0a6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9aa0a6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 169.53,
    y1: 85.46,
    x2: 141.69,
    y2: 85.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9aa0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9ea4aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#abb0b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdc1c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 169.53,
    y1: 33.13,
    x2: 141.69,
    y2: 33.13,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 210.39,
    y1: 157.77,
    x2: 210.39,
    y2: 139.8,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 864.23,
    y1: 634.5,
    x2: 864.23,
    y2: 629.09,
    gradientTransform: "translate(-522.78 -670.86) rotate(7.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#e8eaed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8cbd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 856.88,
    y1: 618.66,
    x2: 871.84,
    y2: 618.66,
    gradientTransform: "translate(-606.42 -568.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f29900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 328.32,
    y1: 31.14,
    x2: 255.85,
    y2: 93.82,
    gradientTransform: "translate(316.01 -183.45) rotate(82.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 116.86,
    y1: 36.59,
    x2: 72.46,
    y2: 74.45,
    gradientTransform: "translate(136.58 18.79) rotate(82.6)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 668.12,
    y1: 618.11,
    x2: 668.12,
    y2: 626.81,
    gradientTransform: "translate(-537.71 -640.21) rotate(7.1)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 114.49,
    y1: 39.63,
    x2: 87.73,
    y2: 65.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34a853",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34a853",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.4,
    y: 20,
    width: 85.15,
    height: 140
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 174.87,
    y1: 4.83,
    x2: 127.87,
    y2: 87.75,
    gradientTransform: "translate(14.62 -17.78) rotate(8.5)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 232.6,
    y1: 44.47,
    x2: 142.94,
    y2: 100.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285f4",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285f4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -827.5,
    cy: -1194.04,
    r: 31.34,
    gradientTransform: "matrix(0.99, -0.15, -0.15, -0.99, 738.51, -1251.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5. Service specific additional terms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.04,
    y: 117.04,
    width: 42.41,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 90.85,
    y: 127.08,
    width: 42.41,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.98,
    y: 144.72,
    width: 42.41,
    height: 5.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "110.11 112.69 140.24 112.69 140.24 132.78 120.15 122.73 110.11 112.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "160.35 122.73 170.4 132.78 130.23 132.78 140.27 122.73 140.27 38.14 160.35 38.14 160.35 122.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 220.25,
    cy: 38.14,
    r: 10.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 170.4,
    cy: 140.37,
    r: 10.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "230.29 140.37 230.29 38.14 220.25 28.1 150.31 28.1 160.35 38.14 160.35 140.37 170.4 150.41 217.07 150.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M220.25,28.1H150.31l10,10V140.37a10,10,0,0,0,10.05,10h46.67l13.22-10V38.14A10,10,0,0,0,220.25,28.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "160.33 122.74 160.33 132.78 130.2 132.78 140.25 122.74 140.25 38.15 160.33 38.15 160.33 122.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M140.25,38.15a10,10,0,0,1,20.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.24,122.73a10,10,0,1,1-20.09,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100.07,122.73a10,10,0,0,1,20.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M170.4,150.41a10,10,0,0,0,10-10h59.89v10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M250.37,140.37a10,10,0,1,1-20.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M240.33,140.37H180.44a10,10,0,0,1-10,10h69.93a10,10,0,0,0,10-10Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 182.9,
    y1: 44.46,
    x2: 209.35,
    y2: 44.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 174.21,
    y1: 76.23,
    x2: 218.05,
    y2: 76.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 174.21,
    y1: 86.82,
    x2: 218.05,
    y2: 86.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 174.21,
    y1: 97.4,
    x2: 218.05,
    y2: 97.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 174.21,
    y1: 107.88,
    x2: 218.05,
    y2: 107.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 174.21,
    y1: 118.47,
    x2: 218.05,
    y2: 118.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 196.13,
    y1: 129.02,
    x2: 218.05,
    y2: 129.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 182.28,
    y1: 59.83,
    x2: 182.28,
    y2: 59.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 209.97,
    y1: 59.83,
    x2: 209.97,
    y2: 59.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 191.51,
    y1: 59.83,
    x2: 191.51,
    y2: 59.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 200.74,
    y1: 59.83,
    x2: 200.74,
    y2: 59.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 211.92,
    y: 56.96,
    width: 101,
    height: 62.35,
    transform: "translate(141.2 337.01) rotate(-82.6)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 211.92,
    y: 56.96,
    width: 101,
    height: 62.35,
    transform: "translate(141.2 337.01) rotate(-82.6)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 274.86,
    y1: 52.28,
    x2: 287.21,
    y2: 53.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 272.43,
    y1: 70.97,
    x2: 284.78,
    y2: 72.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 244.87,
    y1: 76.89,
    x2: 283.57,
    y2: 81.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 243.66,
    y1: 86.23,
    x2: 282.36,
    y2: 91.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 242.45,
    y1: 95.57,
    x2: 281.14,
    y2: 100.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 241.24,
    y1: 104.82,
    x2: 279.94,
    y2: 109.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 263.01,
    y1: 117.15,
    x2: 278.73,
    y2: 119.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M247.42,54.19l7.38,8.69a2.32,2.32,0,0,0,3.12.39l9.3-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M257.92,63.27a2.32,2.32,0,0,1-3.12-.39l-7.38-8.69L245.56,69l19.8,2.48,1.86-14.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M257.92,63.27a2.32,2.32,0,0,1-3.12-.39l-.21-.25-9,6.41,19.8,2.48-7.17-8.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M257.79,63.27a2.32,2.32,0,0,1-3.12-.39l-.21-.25-9,6.41,19.79,2.48-7.16-8.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M265.49,50.35l-14.84-1.86-.76,6-.28,2.27,5.19,6.11a2.32,2.32,0,0,0,3.12.39l6.54-4.64.28-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M257,59h0a1.88,1.88,0,0,1-1.63-2.1h0a1.87,1.87,0,0,1,2.54-1.51l.5.19-.32,2.57A1,1,0,0,1,257,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M258.11,57.68a1.43,1.43,0,1,0,2.83.36l0-.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M256.61,61.09a3.92,3.92,0,1,1,4.37-3.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 250.46,
    y: 49.41,
    width: 14.96,
    height: 2.14,
    transform: "translate(8.28 -31.68) rotate(7.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 211.92,
    y: 56.96,
    width: 101,
    height: 62.35,
    transform: "translate(141.2 337.01) rotate(-82.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 7.09,
    y: 55.96,
    width: 101,
    height: 62.35,
    transform: "translate(-36.24 133.02) rotate(-82.6)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 7.09,
    y: 55.96,
    width: 101,
    height: 62.35,
    transform: "translate(-36.24 133.02) rotate(-82.6)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 70.03,
    y1: 51.28,
    x2: 82.39,
    y2: 52.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 41.46,
    y1: 66.57,
    x2: 79.96,
    y2: 71.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 40.05,
    y1: 75.89,
    x2: 78.74,
    y2: 80.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 38.83,
    y1: 85.23,
    x2: 77.53,
    y2: 90.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 37.62,
    y1: 94.57,
    x2: 76.32,
    y2: 99.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 36.42,
    y1: 103.82,
    x2: 75.11,
    y2: 108.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 59.4,
    y1: 116.31,
    x2: 73.9,
    y2: 118.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 7.09,
    y: 55.96,
    width: 101,
    height: 62.35,
    transform: "translate(-36.24 133.02) rotate(-82.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M58.58,48.29l-9.91-1.24a6.25,6.25,0,1,0-1.54,12.4l3.72.46,4.33,5.57.62-5,1.24.15a6.24,6.24,0,1,0,1.54-12.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M52.24,58.82l-3.72-.46A6.24,6.24,0,0,1,44.8,47.84a6.24,6.24,0,0,0,2.33,11.61l3.72.46,4.33,5.57L55.49,63Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "83.55 47.69 89.24 85.72 94.39 46.07 83.55 47.69"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 95.73,
    y: 38.94,
    width: 62.35,
    height: 101,
    transform: "translate(-11.83 19.74) rotate(-8.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 95.73,
    y: 38.94,
    width: 62.35,
    height: 101,
    transform: "translate(-11.83 19.74) rotate(-8.5)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 129.04,
    y1: 51.55,
    x2: 141.36,
    y2: 49.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 131.82,
    y1: 70.18,
    x2: 144.15,
    y2: 68.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 106.95,
    y1: 83.43,
    x2: 145.54,
    y2: 77.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 108.34,
    y1: 92.75,
    x2: 146.94,
    y2: 86.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 109.74,
    y1: 102.06,
    x2: 148.33,
    y2: 96.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 111.11,
    y1: 111.29,
    x2: 149.71,
    y2: 105.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: 135.2,
    y1: 117.22,
    x2: 151.1,
    y2: 114.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 95.73,
    y: 38.94,
    width: 62.35,
    height: 101,
    transform: "translate(-11.83 19.74) rotate(-8.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "152.06 136.74 165.21 134.78 152.06 46.82 152.06 136.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M126.36,73.71A1.46,1.46,0,0,0,127.6,72l-2.29-14.78A1.48,1.48,0,0,0,123.62,56l-14.36,2.23,8.5,16.78,8.6-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M123.72,56.71a.79.79,0,0,1,.61.14.8.8,0,0,1,.32.51l2.29,14.78a.79.79,0,0,1-.15.59.82.82,0,0,1-.53.32l-8.12,1.26-7.86-15.52,13.44-2.08m-.1-.67-14.36,2.23,8.5,16.78,8.6-1.34A1.46,1.46,0,0,0,127.6,72l-2.29-14.78A1.48,1.48,0,0,0,123.62,56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "115.76 71.08 117.76 75.05 120.9 70.29 115.76 71.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M103.76,54.57a1.5,1.5,0,0,0-1.24,1.71l2.32,15a1.5,1.5,0,0,0,1.7,1.24l14.36-2.22-8.54-17.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M123.62,56l-9.15,1.42-2.11-4.22-8.6,1.33a1.5,1.5,0,0,0-1.24,1.71l2.32,15a1.5,1.5,0,0,0,1.7,1.24l9.22-1.42,2,4,8.6-1.34A1.46,1.46,0,0,0,127.6,72l-.91-5.91-1.38-8.87A1.48,1.48,0,0,0,123.62,56Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    width: 20,
    height: 180
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 300,
    width: 20,
    height: 180
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 150,
    y: -150,
    width: 20,
    height: 320,
    transform: "translate(170 -150) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 150,
    y: 10,
    width: 20,
    height: 320,
    transform: "translate(330 10) rotate(90)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullLists);
export default __webpack_public_path__ + "static/media/nullLists.9f08e25809be53ef9a7e34a2f0980b9f.svg";
export { ForwardRef as ReactComponent };